module.exports = __webpack_public_path__ + "static/media/image1.a0694854.jpg";